// src/auth/index.js

var client = require('./client');
import {router} from '../main'
import {vm} from '../main'

export default {

  // User object will let us check authentication status
  user: {
    authenticated: false
  },

  deactivate(context, id){
    var qs = require('qs');

    client.post('/user/deactivate/', qs.stringify({'id':id}), (data)=>{
    }).then((response)=>{
      if (response.data.status){
        context.deactivated = true
        window.location.reload()
      }else{

      }
    })
  },


  async signature(context, products){
    var qs = require('qs');
    return client.post('/user/signature/', {products});
  },

  prefill(context,source,payload=null){
    context.loading = true

    var qs = require('qs');
    client.post('/user/prefilled/', qs.stringify({'token':source,'payload':payload}), (data)=>{
    }).then((response)=>{
      //if (response.data.status==='true'){
        context.payload = response.data.payload
        if(response.data.payload){
          context.credentials = response.data.payload
        }
        context.logo = response.data.logo
        context.style = response.data.style
        context.disclaimer = response.data.disclaimer

        if(response.data.style !=''){
          /* create the link element */
          var linkElement = document.createElement('link');

          /* add attributes */
          linkElement.setAttribute('rel', 'stylesheet');
          linkElement.setAttribute('type', 'text/css');
          linkElement.setAttribute('href', response.data.style);

          /* attach to the document head */
          document.getElementsByTagName('head')[0].appendChild(linkElement);
        }
      //}else{

      //}
    });
    context.loading = false
  },

  async getCompany(context){
    var user = localStorage.getItem('userdata')
    console.log(user)
    context.loading = false
    var parsami = JSON.parse(user)
    var user_id = parsami.id
    return await client.post('/user/companies/', {'user_id':user_id}, (data) => {
    }).then((response) => {
      if (response.data.status){
        context.companies = response.data.companies
        context.mycompany = context.companies[0].id
        context.company = context.companies[0].id
        context.ready = true
        //console.log(context.companies[0].id)
        context.loading = false
      }else{
        context.mycompany = null
      }
    })
    .catch((error) => {
      if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            //console.log(error.response.data);
            //console.log(error.response.status);
            //console.log(error.response.headers);
        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            //console.log(error.request);
        } else {
            // Something happened in setting up the request and triggered an Error
            //console.log('Error', error.message);
        }
        //console.log(error.config);
        localStorage.clear();
        router.push('/login')
    });
  },

  async getCanbuy(context){
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_id = parsami.id
    return await client.post('/user/withreseller/', {'user_id':user_id}, (data) => {
    }).then((response) => {
        if (response.data.status){

          if(response.data.reseller > 0){
            //console.log(response.data.reseller)
            localStorage.setItem('canBuy', false)
          } else {
            localStorage.setItem('canBuy', true)
          }
      }else{
        context.mycompany = null
      }
    })
  },

  async getSettings(context){
    context.loading = true
    return await client.get('/settings/key/frontend.video').then((response) => {
          context.video = response.data.settings[0].setting_value;
          context.loading = false
    })
    context.loading = false
  },

  async getOrders(context, user, company){
    context.loading = true
    var qs = require('qs');
    return await client.post('/user/orders/', qs.stringify({'user_id':user, 'company':company}), (data)=>{
    }).then((response)=>{
      //console.log(response.data.orders)
      if (response.data.status){
        localStorage.setItem('reseller', company)
        localStorage.setItem('myorders', response.data.orders)
        context.myorders = response.data.orders


        var products = []
        var i=0
        var arr = [];
        response.data.orders.forEach(function(element) {
          var j=0
          if(context.ordersExport){
            context.ordersExport[i] = {

                'PurchaseId': response.data.orders[i].PurchaseId,
                'BillingContactTitle': response.data.orders[i].BillingContactTitle,
                'BillingContactLastName': response.data.orders[i].BillingContactLastName,
                'BillingContactFirstName': response.data.orders[i].BillingContactFirstName,
                'BillingContactEmail': response.data.orders[i].BillingContactEmail,
                'BillingContactCompany': response.data.orders[i].BillingContactCompany,
                'VatId': response.data.orders[i].VatId,
                'PurchaseDate': response.data.orders[i].PurchaseDate
              }
            }

            //products[i] = periodo

              response.data.orders[i].products.forEach(function(element) {
              response.data.orders[i].products[j].order_id = response.data.orders[i].id
              if(!arr.includes(response.data.orders[i].products[j].id))  {
                if(response.data.orders[i].products[j].family){
                  products.push(response.data.orders[i].products[j])
                  arr.push(response.data.orders[i].products[j].id)
                }
              }

              j++
            });
            i++
        });
        
        products.sort((a, b) => a.family.localeCompare(b.family));
        context.myproducts = products
        this.getFreeProducts(context, user, company)
      }

      //console.log('context.myproducts',context.myproducts)

      context.orders_loaded = false
      context.loading = false
    })

  },

  async getFreeProducts(context, user, company){

    context.loading = true
    context.orders_loaded = false
    var qs = require('qs');
    return await client.post('/user/freeproducts/', qs.stringify({'user_id':user, 'company':company}), (data)=>{
    }).then((response)=>{
      //console.log(response.data)
      if (response.data.status){
        response.data.products.forEach(function(element) {
          //console.log('free',element)
          context.myproducts.push(element)
        });
      }
      context.loading = false
      context.orders_loaded = true


      //console.log('context.myproducts',context.myproducts)
    })

  },

  async getCatalog(context, user, company){
    context.loading = true
    context.loadingCatalog = true
    var qs = require('qs');
    return await client.post('/user/catalog/', qs.stringify({'user_id':user, 'company':company, 'country': context.country}), (data)=>{
    }).then((response)=>{
      if (response.data.status){
        context.catalog = response.data.products
        context.upgrades = response.data.upgrades
        let total = 0;
        for(let i = 0; i < response.data.products.length; i++){
          if(response.data.products[i].isBundle){
            total++;
          }
        }
        if(response.data.upgrades.length && response.data.upgrades.cart.length){
          context.totalProdOnlyForYou =  total + response.data.upgrades.cart.length
        }
        /*if(context.totalProdOnlyForYou > 0){
          context.selectTab('only');
        }*/
      }
      //console.log('catalog', response.data);
      localStorage.setItem('catalog', JSON.stringify(context.catalog))
      context.loadingCatalog = false
      context.loading = false
      console.log('context.catalog',context.catalog)
    })

  },

  getKeys(context, item){
    context.loading = true
    //console.log(context.myorders)
    var mykeys = []
    var orders = []
    context.myorders.forEach(function(element) {
      element.products.forEach(function(product) {
        if(product.id == item.id){
          orders.push(element.id)
          product.keys.forEach(function(key) {
              mykeys.push(key)
          });
        }
      });
    });
    //console.log(orders)
    localStorage.setItem('mykeys', JSON.stringify(mykeys))
    localStorage.setItem('orderid', item.order_id)
    localStorage.setItem('current_orders', orders)
    localStorage.setItem('item', JSON.stringify(item))
    context.mykeys = mykeys
    context.loading = false
    return mykeys
  },

  getDownload(context, id, item){
    context.loading = true
    localStorage.removeItem('other_downloads')
    localStorage.removeItem('downloads')
    var qs = require('qs');
    client.post('/user/downloads/', qs.stringify({'id_product':id}), (data) => {
    }).then((response) =>{
      if(response.data.status){
        var parsami = JSON.stringify(response.data)
        localStorage.setItem('downloads', parsami)

        //manuali ed altri file
        client.post('/user/shared_downloads/', qs.stringify({'id_product':id}), (data) => {
        }).then((response) =>{
          if(response.data.status){
            var parsami2 = JSON.stringify(response.data.downloads)
            localStorage.setItem('other_downloads', parsami2)
            //var parsami3 = JSON.stringify(mykeys)
            //localStorage.setItem('mykeys', parsami3)

            context.loading = true
            //console.log(context.myorders)
            var mykeys = []
            var orders = []
            context.myorders.forEach(function(element) {
              element.products.forEach(function(product) {
                if(product.id == item.id){
                  orders.push(element.id)
                  product.keys.forEach(function(key) {
                      mykeys.push(key)
                  });
                }
              });
            });
            //console.log(orders)
            localStorage.setItem('mykeys', JSON.stringify(mykeys))
            localStorage.setItem('orderid', item.order_id)
            localStorage.setItem('current_orders', orders)
            localStorage.setItem('item', JSON.stringify(item))



            router.push('/keys')
          } else {
            localStorage.removeItem('other_downloads')
          }
        })

      }else{
        localStorage.setItem('downloads', '')
        context.err = response.data.error
      }
    })



  },

  sendEmail(context, token, company, user){
    context.loading = true
    var qs = require('qs');
    client.post('/user/notify/', qs.stringify({'code':token, 'user_id':user, 'company_id':company}), (data) => {
    }).then((response) =>{
      context.loading = false
      if(response.data.status){
        context.email = 'The email was sent successfully, please check your inbox.'
        localStorage.setItem('trans_code',token)
        localStorage.setItem('status2',true)
        router.push('/add-order')
      }else{
        context.err = response.data.error
      }
    })
  },

  getFile(context, id, filename){
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_id = parsami.id
    var qs = require('qs');
    var uid = (new Date().getTime()).toString(36)
    client.get('/download/?uid='+uid+'&id_file='+id+'&user_id='+parsami.id, {responseType:'arraybuffer'}).then((response)=>{
      if(response.data && response.data.status!=false){
        var blob = new Blob([response.data], {type: 'application/zip' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }else if(response.data.status==false){
        context.error = true
      }
    })
  },

  // Send a request to the login URL and save the returned user_id
  login(context, creds) {
    let redeem_code = null;
    context.loading = true
    var qs = require('qs');
    let ref_token = null
    if(localStorage.getItem('ref_token'))  ref_token = localStorage.getItem('ref_token')
    if(localStorage.getItem('promo_redeem_code'))  redeem_code = localStorage.getItem('promo_redeem_code')
    if(creds.ref_token && creds.ref_token != '')  ref_token = creds.ref_token
    if(creds.redeem_code && creds.redeem_code != '')  redeem_code = creds.redeem_code
    localStorage.clear()
      client.post('auth/token', qs.stringify(creds), (data) => {
      }).then((response) => {
        if (response.data.status){
          localStorage.setItem('access_token', response.data.token)
          client.defaults.headers.common['Authorization'] = response.data.token
          client.post('/user/authenticate/?uid='+new Date().getTime(), qs.stringify(creds), (data) => {
            if(data.status && data.status == 'true'){
              this.user.authenticated = true
            }
          }).then((response) => {
              if (response.data.status){
                this.user.authenticated = true
                var data = JSON.stringify(response.data)
                localStorage.setItem('userdata', data)
                localStorage.setItem('reseller', 0)
                localStorage.setItem('localstorage_version', '2')
                if(context.$route.query.sso=='true'){
                  //console.log(document.referrer)
                  location.href = document.referrer
                }

                
                if(ref_token) return router.push('/freeproduct/'+ref_token)

                if(context.payload && context.payload != ''){
                  router.push({name: 'addOrder', params: { redeem_code: context.payload.redeem_code }})
                  //router.push('/add-order')
                   console.log('a',context.payload)
                } else if(redeem_code && redeem_code !='') {
                  console.log('b',redeem_code)
                  router.push({name: 'addOrder', params: { redeem_code: creds.redeem_code }})
                } else {
                  router.push('/')
                }
              }else{

                  context.loginErr = response.data.error
              }
              if(ref_token) localStorage.setItem('ref_token', ref_token)
              if(redeem_code) localStorage.setItem('promo_redeem_code', redeem_code)
              context.loading = false
          })
        } else {
          if(ref_token) localStorage.setItem('ref_token', ref_token)
          context.loginErr = response.data.error
          context.ref_token = ref_token
          context.loading = false
        }
      })
  },

  signup(context, creds) {
    context.loading = true
    localStorage.clear()
    var qs = require('qs')
    context.loading = true
    client.get('auth/token', (data) => {
      }).then((response) => {
        localStorage.setItem('access_token', response.data.token)
        client.defaults.headers.common['Authorization'] = response.data.token
        client.post('/user/register/', qs.stringify(creds), (data) => {
          }).then((response)=> {

            context.loading = false
            if (response.data.status){
              if(creds.ref_token) localStorage.setItem('ref_token',creds.ref_token)
              if(creds.redeem_code) localStorage.setItem('promo_redeem_code', creds.redeem_code)
                console.log({'username':creds.username, 'password':creds.password, 'ref_token': creds.ref_token, 'redeem_code': creds.redeem_code})
              this.login(context, {'username':creds.username, 'password':creds.password, 'ref_token': creds.ref_token, 'redeem_code': creds.redeem_code})
            }else{
              context.signupErr = response.data.errors
              window.scrollTo(0,0)
            }

            if(creds.ref_token) localStorage.setItem('ref_token',creds.ref_token)
            if(creds.redeem_code) localStorage.setItem('promo_redeem_code', creds.redeem_code)
        })
      })
  },

  // To log out, we just need to remove the token
  logout(context) {
    client.get('user/logout', (data) => {
      }).then((response) => {
        localStorage.clear()
        this.user.authenticated = false
        if(context.$route.query.sso=='true'){
          location.href = document.referrer
        }
        router.push('/login')
      })
  },

  // To log out, we just need to remove the token
  deleteAccount(context,user) {
    context.loading = true

    client.get('user/remove', (data) => {
      }).then((response) => {
        localStorage.clear()
        this.user.authenticated = false
        router.push('/login')
      })

  },

  recoverPass(context, email){
    localStorage.clear()
    var qs = require('qs')
    context.loading = true
    client.get('auth/token', (data) => {
      }).then((response) => {
        localStorage.setItem('access_token', response.data.token)
        client.defaults.headers.common['Authorization'] = response.data.token
        var url = process.env.RESET_URL
        client.post('/user/forgot_password/', qs.stringify({'email':email, 'url':url}) , (data) => {
        }).then((response)=>{
          context.loading = false
          if(response.data.status){
            context.success = true
          }else{
            context.recoverErr = response.data.error
          }

        })
    })
  },

  updateProfile(context, first_name, last_name, gdpr_email, gdpr_advertising, email, old_email){
    context.loading = true
    var qs = require('qs');
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_id = parsami.id

    client.post('/user/update_profile/', qs.stringify({'user_id':user_id, 'first_name':first_name, 'last_name':last_name, 'gdpr_email': gdpr_email, 'gdpr_advertising': gdpr_advertising, 'email':email, 'old_email':old_email}), (data) => {
      }).then((response)=> {
        context.loading = false
        if (response.data.status){

          // refresh localstorage userdata
          parsami.first_name = first_name
          parsami.last_name = last_name
          parsami.email = email
          var stringato = JSON.stringify(parsami)
          localStorage.setItem('userdata', stringato)

          context.utente = JSON.parse(stringato)

          context.updatedProfile = true
        }else{
          context.settErr = response.data.error
          context.updatedProfile = false
        }
      });
  },

  changePwd(context, email, username, current_password, new_password, confirm_password){
    var qs = require('qs');
    context.loading = true
    //var user = localStorage.getItem('userdata')
    //var parsami = JSON.parse(user)
    //var user_id = parsami.id
    //var username = parsami.username
    client.post('/user/change_password/', qs.stringify({'username':username, 'email':email, 'current_password':current_password, 'new_password':new_password, 'confirm_password':confirm_password}), (data) => {
      }).then((response)=> {
        context.loading = false
        if (response.data.status){
          bootbox.alert('Password changed!')
        }else{
          context.pwdErr = response.data.error
          context.updated = false
        }
      });
  },

  resetPass(context, credentials){

    localStorage.clear()
    var qs = require('qs');
    context.loading = true
    client.get('auth/token', (data) => {
      }).then((response) => {
          localStorage.setItem('access_token', response.data.token)
          client.defaults.headers.common['Authorization'] = response.data.token
          context.disableButton = true
          client.post('/user/reset_password/', qs.stringify(credentials), (data) => {
            }).then((response)=> {
              context.loading = false
              if (response.data.status){
                context.success = true
              }else{
                context.success = false
                context.recoverErr = response.data.error
                context.disableButton = false
              }
            })
    })
  },

  getToken(context, id_file, minutes, license_type = 'REG') {
      context.loading = true
      client.get('auth/token/', minutes,(data) => {
      }).then((response) => {
        if(response.data.token){
          var user = localStorage.getItem('userdata')
          var parsami = JSON.parse(user)
          var user_id = parsami.id

          var path = process.env.API_URL + '/download/?license_type='+license_type+'&id_file='+id_file+'&user_id='+parsami.id+'&uid='+response.data.token
          var link = document.createElement('a')
          link.href = path

          var clickEvent = new MouseEvent("click", {    "view": window,    "bubbles": true,    "cancelable": false});
          link.dispatchEvent(clickEvent);

          context.loading = false
        }else
        {
          context.error = true
          context.loading = false
        }

      })
  },

  checkToken() {
    //console.log(localStorage.getItem('access_token'));
   // var jwt = localStorage.getItem('access_token')
    //if(jwt === null || !jwt || jwt == 'undefined' || typeof jwt === 'object') {
      localStorage.clear()
      client.get('auth/token', (data) => {
      }).then((response) => {
        localStorage.setItem('access_token', response.data.token)
        //return response.data.token
      })
    //}
  },

  checkAuth() {
    var userdata = localStorage.getItem('userdata')
    if(!userdata && window.location.pathname != '/logout' && window.location.pathname != '/forgotpassword' && window.location.pathname != '/reset') router.push('/login')
    var version = localStorage.getItem('localstorage_version')

    var parsami = JSON.parse(userdata)
    var user_id = parsami.id
    var user_email = parsami.email



    if(userdata && window.location.pathname != '/logout' && window.location.pathname != '/forgotpassword' && window.location.pathname != '/reset' && version && version == '2') {
      this.user.authenticated = true
      if(!window.location.pathname.includes("freeproduct")) router.push('/')
      if(localStorage.getItem('promo')) {
        if(localStorage.getItem('promo_email') != user_email) {
          localStorage.setItem('userdata','')
          return
        
        }
        router.push({name: 'addOrder', params: { redeem_code: localStorage.getItem('promo_redeem_code') }})
      }
    } else {
      localStorage.clear()
      this.user.authenticated = false
      if (window.location.pathname != '/login' && window.location.pathname != '/register' && window.location.pathname != '/logout'
          && window.location.pathname != '/reset' && window.location.pathname != '/update-browser' && window.location.pathname != '/recover' && window.location.pathname != '/forgotpassword' && window.location.pathname != '/recover' && !window.location.pathname.includes("freeproduct")){
          router.push('/logout')
      }

      if(window.location.pathname == '/logout') {
        this.logout()
      }
    }
  },

  assignTransaction(context, key){
    context.loading = true
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_id = parsami.id
    var user_email = parsami.email
    var qs = require('qs');
    client.post('/user/assign_transaction/', qs.stringify({'user_id':user_id, 'key':key}), (data) => {
      }).then((response)=> {
        context.loading = false
        if (response.data.status){
          context.addOrderErr = null
          localStorage.setItem('trans_code', response.data.code)
          context.step1 = false
          context.step2 = true
          context.email = user_email
        }else{
          context.addOrderErr = response.data.error
        }
      });
  },
  activate(context, item){
    context.loading = true
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_email = parsami.email
    var qs = require('qs');
    client.post('/activation/company/'+context.company, qs.stringify({'code1':context.code1, 'code2':context.code2, 'method':'offline', 'email':user_email,'label':context.label}), (data) => {
      }).then((response)=> {
        //console.log(response)
        if(response.data.response.activation._attributes.status!='failure'){
          this.updateKeys(context,item)
          //context.loading = false
          context.showModalOffline = false
          //router.push('/keys')
        } else {
          context.loading = false
          //context.showModal = false
          context.errorsActivation = response.data.response.message
        }
      });
  },
  async updateKeys(context,item){
    var user = localStorage.getItem('userdata')
    this.getOrders(context, user, context.company).then(result =>{
          this.getKeys(context, item)
    })
  },
  assignTransactionRc(context, rCode){
    context.loading = true
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_id = parsami.id
    var user_email = parsami.email
    var user_first_name = parsami.first_name
    var user_last_name = parsami.last_name
    var qs = require('qs');
    client.post('/user/assign_transaction_rc/', qs.stringify({'key':rCode, 'user_id':user_id, 'email':user_email, 'first_name':user_first_name, 'last_name':user_last_name}), (data) => {
      }).then((response)=> {
        context.loading = false
        if (response.data.status){
          context.addOrderErr = null
          context.step1 = false
          context.step2 = true
          context.email = user_email
          localStorage.setItem('trans_code', response.data.code)
          window.fbq('trackCustom', 'Redeem', { products: response.data.products, status: true })
        }else{
          context.addOrderErr = response.data.error
          window.fbq('trackCustom', 'Redeem', { status: false })
        }
      });
      context.loading = false
  },
  checkTrans(context){
    context.loading = false
    var trans_code = localStorage.getItem('trans_code')
    var qs = require('qs');
    client.post('user/check_transaction', qs.stringify({'code':trans_code}), (data) => {
    }).then((response)=>{
      context.loading = false
      if (response.data.status){
        context.addOrderErr = null
        context.step1 = false
        context.step2 = false
        context.step3 = true
        localStorage.setItem('ref_token', '')
        localStorage.setItem('promo_redeem_code', '')
      }
    })
  },

  // The object to be passed as a header for authenticated requests
  getAuthHeader() {
    var token = localStorage.getItem('access_token')
    return token
  },
  // The object to be passed as a header for authenticated requests

  getUserData(key){
    var userdata = localStorage.getItem('userdata')
    return userdata[key]
  },
  //fastspring order detail
  getFastSpringOrder(context){
    context.loading = true
    var qs = require('qs');
    const defaultHeaders = JSON.parse(JSON.stringify(client.defaults.headers));

    var fastspring = context.axios.create({
      baseURL: 'https://api.fastspring.com/',
      withCredentials: false,
      auth: {
        username: '4VPUB4U4QWSRIRB1R4DDRG',
        password: 'SzWUgu_XT-qdDOCmF6qiIw'
      }
    })

    fastspring.defaults.headers.common = []
    fastspring.defaults.headers.common['Content-Type'] = 'application/json'
    fastspring.defaults.headers.common['Origin'] = 'http://localhost'
    fastspring.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

    client.defaults.headers = defaultHeaders;

      fastspring.get('accounts/?orderReference=AUD180807-4534-21122').then(function(response) {
        //console.log('Authenticated');
        //console.log(response);
      }).catch(function(error) {
        //console.log('Error on Authentication');
        //console.log(error);
      });

  },

  //fastspring account detail
  getFastSpringAccount(context){
    context.loading = true
    var qs = require('qs');
    var user = localStorage.getItem('userdata')
    var parsami = JSON.parse(user)
    var user_id = parsami.id
    client.post('/user/fastspringaccount/', qs.stringify({'user_id':user_id}), (data)=>{
    }).then((response)=>{
      if (response.data.status){
        context.fastspring_user = response.data.account
        //console.log(response);
      }
      context.loading = false
    })

  },

  getFreeProduct(context, token){
    context.loading = true
    var qs = require('qs');
    client.post('user/getfreeproduct', qs.stringify({'token':token}), (data) => {
    }).then((response)=>{
      context.loading = false
      if (response.data.status){
        console.log(response.data.product)
        context.product = response.data.product
        context.form = response.data.form
        context.header_image = !context.registered ? context.product.header_image : "https://static.audiomodeling.com/images/landing/SC_mobile_banner.png"
      }
    })
  },
  registerFreeProduct(context, token){
    context.loading = true
    var qs = require('qs');
    client.post('user/registerfreeproduct', qs.stringify({'token':token}), (data) => {
    }).then((response)=>{
      context.loading = false
      if (response.data.status){
        context.registered = true
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/auth/index.js